import React from 'react'
import DmLayout from '../../components/dm/Layout'

export default function Dm() {
    return (
        <div>
            <DmLayout />
        </div>
    )
}
